import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="post-harvest-operator-import"
export default class extends Controller {
  static targets = ["select", "name"];
  static values = { users: Object };

  import() {
    const userId = this.selectTarget.value;
    if (!userId) return;

    const user = this.usersValue[userId];
    if (!user) return;

    this.nameTarget.value = user.name;
    this.selectTarget.value = "";
  }
}
